// AUTO-GENERATED by scripts/build-splash-content.ts — do not edit.
// Regenerated on every `bun run dev` / `bun run build` from
// data/splash.json + data/me.json + data/journey.json.
// Committed so fresh checkouts typecheck.

export const VISITED_COUNTRY_COUNT = 53;
export const CONTINENT_COUNT = 7;
export const SPLASH_NAME = "Miles Kendrick McCrocklin";
export const SPLASH_PORTRAIT = "/media/summary/portrait.jpg";
export const SPLASH_TAGLINE = "Ten years at FB supporting teams, fighting misinformation, and building prediction markets. A sabbatical since: seven continents, thousands of stories captured in frame. Back to building.";
export const SOCIALS = [
  {
    "id": "github",
    "href": "https://github.com/milroc",
    "label": "GitHub"
  },
  {
    "id": "linkedin",
    "href": "https://www.linkedin.com/in/miles-mccrocklin-7b635127",
    "label": "LinkedIn"
  },
  {
    "id": "twitter",
    "href": "https://twitter.com/Milr0c",
    "label": "X (Twitter)"
  },
  {
    "id": "instagram",
    "href": "https://instagram.com/milroc",
    "label": "Instagram"
  },
  {
    "id": "threads",
    "href": "https://threads.com/@milroc",
    "label": "Threads"
  },
  {
    "id": "email",
    "href": "mailto:miles@mccrockl.in",
    "label": "Email"
  }
] as const;
export const DOORS = [
  {
    "id": "builder",
    "href": "/builder/",
    "thumb": "/media/meta-misinformation/fact-check-labels.jpg",
    "label": "BUILDER",
    "sublabel": "technologist",
    "cta": "the work →",
    "aria": "Builder — view resume"
  },
  {
    "id": "photographer",
    "href": "/photographer/",
    "thumb": "/media/summary/chinstrap-traverse.jpg",
    "label": "PHOTOGRAPHER",
    "sublabel": "artist",
    "cta": "the frames →",
    "aria": "Photographer — view the gallery"
  }
] as const;
export const EXPLORER_DOOR = {
  "href": "/explorer/",
  "label": "EXPLORER",
  "sublabel": "traveler",
  "cta": "the journey →",
  "aria": "Explorer — fullscreen globe of every country I've been to"
} as const;
